/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoRating from "../../Modulo_formularios/Componentes/IngresoRating";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Formulario_Producto = ({...props}) => {
    const {sCell, masSM} = useResponsive()


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: !masSM ? 32 : 40, color: theme.palette.primary.main}}>4.8</Typography>
                </Grid>

                <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{color: '#828282', fontSize: 14, lineHeight: 1.1}}>56.000</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{color: '#828282', fontSize: 14, lineHeight: 1.1}}>calificaciones</Typography>
                        </Grid>


                    </Grid>
                </Grid>


                <Grid container size={{xs: 5, sm: 5, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoRating dato={'calificacion'} nombre={''}  {...props}
                                   requerido={'La calificacion es requerida'}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={4} nombre={'Comentarios del producto'} dato={'comentarios'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto